var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashLeftIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.92529C22 12.5153 19.09 15.4253 15.5 15.4253C15.33 15.4253 15.15 15.4153 14.98 15.4053C14.73 12.2353 12.19 9.69528 9.01999 9.44528C9.00999 9.27528 9 9.09529 9 8.92529C9 5.33529 11.91 2.42529 15.5 2.42529C19.09 2.42529 22 5.33529 22 8.92529Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.9253C15 19.5153 12.09 22.4253 8.5 22.4253C4.91 22.4253 2 19.5153 2 15.9253C2 12.3353 4.91 9.42529 8.5 9.42529C8.67 9.42529 8.84999 9.43528 9.01999 9.44528C12.19 9.69528 14.73 12.2353 14.98 15.4053C14.99 15.5753 15 15.7553 15 15.9253Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59 2.42529H3C2.45 2.42529 2 2.87529 2 3.42529V6.01529C2 6.90529 3.07999 7.35528 3.70999 6.72528L6.29999 4.13528C6.91999 3.50528 6.48 2.42529 5.59 2.42529Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4097 22.4253H20.9997C21.5497 22.4253 21.9997 21.9753 21.9997 21.4253V18.8353C21.9997 17.9453 20.9197 17.4953 20.2897 18.1253L17.6997 20.7153C17.0797 21.3453 17.5197 22.4253 18.4097 22.4253Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashLeftIcon03);
export default __webpack_public_path__ + "static/media/dash-left-icon03.72db57109e0534e0f4be3e53bd116a54.svg";
export { ForwardRef as ReactComponent };